var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5253 4.75032e-05L5.45618 0C2.28665 0 0 2.56151 0 5.85897V12.141C0 15.4385 2.28665 18 5.45618 18H14.5168C16.0392 17.9829 17.4802 17.3421 18.5126 16.2266C19.5449 15.111 20.0786 13.6183 19.9893 12.0959L19.9906 5.85897C20.0786 4.38171 19.5449 2.88895 18.5126 1.77344C17.4802 0.657936 16.0392 0.0170508 14.5253 4.75032e-05ZM5.45618 1.52843L14.5084 1.52838C15.6073 1.54072 16.6532 2.00592 17.4026 2.81562C18.152 3.62533 18.5393 4.70887 18.4745 5.81389L18.4732 12.141C18.5393 13.2911 18.152 14.3747 17.4026 15.1844C16.6532 15.9941 15.6073 16.4593 14.5084 16.4716L5.45618 16.4716C3.16279 16.4716 1.51744 14.6284 1.51744 12.141V5.85897C1.51744 3.37155 3.16279 1.52843 5.45618 1.52843ZM16.024 5.63837C15.7622 5.30886 15.2847 5.25555 14.9576 5.5193L10.8583 8.82425L10.7408 8.90681C10.2575 9.20955 9.62278 9.18159 9.15981 8.81812L5.03057 5.51731L4.93763 5.4536C4.61736 5.26727 4.20141 5.34031 3.96461 5.64086C3.70412 5.97146 3.75904 6.45216 4.08726 6.71453L8.22174 10.0195L8.38304 10.1375C9.42309 10.8459 10.8013 10.8067 11.7988 10.0236L15.9058 6.71255L15.9882 6.63551C16.24 6.36261 16.2621 5.93792 16.024 5.63837Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.43e7b435b59e7565a57a2c00a8d59e4a.svg";
export { ForwardRef as ReactComponent };